export default "__VITE_ASSET__9c9b2b37__"